import { getSession } from '@/utils/common';
import { useLocation, useParams } from 'umi';
import * as SESSION_KEYS from '@/configs/session-storage-keys';

interface IReturn {
  create: (values: { [prop: string]: any }) => { [prop: string]: any };
  update: (
    values: { [prop: string]: any },
    oldValues: { [prop: string]: any },
  ) => { [prop: string]: any };
}

interface IUseHandleFormData {
  (): IReturn;
}

const useHandleFormData: IUseHandleFormData = () => {
  const params = useParams<{ type: string }>();
  const productType = params.type;
  const location: any = useLocation();

  const create = (values: { [prop: string]: any }) => {
    const planPicked = getSession(SESSION_KEYS.PICKED_PLAN_INFO);
    const coverageType = planPicked?.coverageType;
    let defaultValues = {};
    switch (productType) {
      case 'motor':
        switch (coverageType) {
          case 'tpl':
            defaultValues = {
              seats_number: 0,
              business_usage: 'No',
              include_pa: values.pa ? 'Yes' : 'No',
              pa_persons_num: values.pa_persons_num ? values.pa_persons_num : 0,
              process_for_buy_now:
                location?.query?.button === 'buyNow' ? true : false,
              tonnage: 0,
            };
            break;
          case 'cpd':
            defaultValues = {
              manufacture_date: 0,
              registration_date: 0,
            };
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }

    return {
      ...defaultValues,
      ...values,
    };
  };

  const update = (
    values: { [prop: string]: any },
    oldValues: { [prop: string]: any },
  ) => {
    return {
      ...oldValues,
      ...values,
    };
  };

  return {
    create,
    update,
  };
};

export default useHandleFormData;
